import React, { Component } from 'react';
import { connect } from 'react-redux';
import {  withRouter } from 'react-router-dom';
import Header from './components/Header/Header';
import Auth from './components/Security/Auth/Auth';
import SignUp from './components/Security/SignUp/SignUp';
import * as actions from './store/actions/index';
import classes from './App.css';
import Delivery from './components/Delivery/Delivery';

class App extends Component {
  state = {
    page: null,
    signingUp: false,
    deliveryId: 0
  }
  componentDidMount() {
    this.props.onTryAutoSignup();
    console.log("In APP DID MOUNT");
    
  }

  setPage = (page) => {
    console.log(page);
    let signUp = false
    if (page == 'signup') {
      signUp = true;  
    }
    this.setState({page:page, signingUp:signUp});
  }

  setLoadDelivery = (deliveryId) => {
    this.setState({deliveryId:deliveryId,page:'loaddelivery'});

  }

  deliveryLoaded = () => {
    this.props.onSendDeliveryOut(this.state.deliveryId);
    this.setState({deliveryId:0,page:'loads'});
  }

  loadDeliveryCancelled = () => {
    this.setState({deliveryId:0,page:'loads'});
  }

  render() {
    let pageToShow = null;
    if (!this.props.isAuthenticated && !this.state.signingUp)
    {
      pageToShow = <Auth setPage={this.setPage} />
    }
    else if (this.state.page =="signup" ) {
      pageToShow = <SignUp setPage={this.setPage} />
    }
    else {
      pageToShow = <Delivery deliveryId={this.state.deliveryId}/>
    }

        return (
          <div className={classes.App} id='app' style={{ "height": "100%" }}>
            <Header />
            {pageToShow}
          </div>  
        );
    }
}

const mapStateToProps = state => {
  console.log(state);
  return {
    isAuthenticated: state.orders.token !== null,
    delivery: state.orders.delivery
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onTryAutoSignup: () => dispatch(actions.authCheckState()),
    onSendDeliveryOut: (deliveryId) => dispatch(actions.sendDeliveryOut(deliveryId)),
    onGetDelivery: () => dispatch(actions.getDelivery())
  };
};

export default withRouter( connect( mapStateToProps, mapDispatchToProps )( App ) );



// WEBPACK FOOTER //
// ./src/App.js